<template>
  <v-content style="width: 100%;" class="mx-auto my-0 pa-0" :style="(init.preview == 1) ? 'padding-bottom:70px;' : ''">
    <div
      class="wrap"
      :style="`background-image: url(`+init.top_background_image+`); background-size: cover; min-height:100vh;`"
    >
      <!-- logo -->
    <v-row align-content="center" justify="center" no-gutters class="logo" :style="{
        backgroundImage: 'url(' + init.top_background_image + ') !important',
        backgroundSize: 'cover !important'
    }">
      <img v-if="init.top_logo_image" :src="init.top_logo_image" style="width:auto; max-width:100%;" />
      <span v-else style="font-weight: bold; font-size: 22px;">{{init.shop_name}}</span>
    </v-row>

      <!-- background & scroll -->
      <div class="body" v-if="menu_list != null" :style="init.top_background_color">
        <div class="slider">
          <slick ref="slick" :options="slickOptions">
            <div v-for="menu in menu_list.menus" :key="menu.id">
              <!-- ポイント -->
              <TopPoint
                v-if="menu.feature_id == 'point' && point"
                :point="point"
                :menu="menu"
                :init="init"
                @set="NextRouting"
              ></TopPoint>
              <!-- クーポン -->
              <TopCoupon
                v-if="menu.feature_id == 'coupon' && coupon"
                :coupon="coupon"
                :menu="menu"
                @set="NextRouting"
              ></TopCoupon>
              <!-- スタンプ -->
              <TopCStamp
                v-if="menu.feature_id == 'stamp' && stamp"
                :stamp="stamp"
                :menu="menu"
                @set="NextRouting"
              ></TopCStamp>
              <!-- リサーブ系 -->
              <TopBooking
                v-if="menu.feature_id == 'booking'"
                :booking="booking"
                :menu="menu"
                @set="NextRouting"
              ></TopBooking>
              <!-- デジチケ系 -->
              <TopDigitalTicket
                v-if="menu.feature_id == 'digital_ticket'"
                :digitalticket="digitalticket"
                :menu="menu"
                :init="init"
                @set="NextRouting"
              ></TopDigitalTicket>
              <!-- プッシュ通知 -->
              <TopNotification
                v-if="menu.feature_id == 'notification' && notification"
                :notification="notification"
                :menu="menu"
                @set="NextRouting"
              ></TopNotification>
              <!-- TALK -->
              <TopTalk
                v-if="menu.feature_id == 'talk'"
                :talk="talk"
                :menu="menu"
                @set="NextRouting"
              ></TopTalk>
              <!-- 外部リンク -->
              <topCExternalLink
                  v-if="menu.feature_id == 'external_links' + menu.shop_menu_id"
                  :menu="menu"
                  @set="NextRouting"
                ></topCExternalLink>
            </div>

            <!-- MOP -->
            <TopMop
              v-if="init.sid == 905017 || init.sid == 904980 || init.sid == 4980 && menuloadflg == 1"
              @set="toMOP"
            ></TopMop>

            <!-- GINDAKO MOP -->
            <TopMopGindako
              v-if="init.sid == 905020"
              @set="toMOP"
            ></TopMopGindako>

            <!-- DELIVERY -->
            <TopDelivery
              v-if="init.sid == 905017 || init.sid == 904980 || init.sid == 4980 && menuloadflg == 1"
              @set="toDelivery"
            ></TopDelivery>

            <!-- RESERVE -->
            <TopReserve
              v-if="init.sid == 905017 || init.sid == 904980 || init.sid == 4980 && menuloadflg == 1"
              @set="toReserve"
            ></TopReserve>

            <!-- SHOPPING -->
            <TopShopping
              v-if="init.sid == 905017 || init.sid == 904980 || init.sid == 4980 && menuloadflg == 1"
              @set="toShopping"
            ></TopShopping>

          </slick>
        </div>
        <!-- NEW_DEV-1831 cyber start -->
        <noticeDialogue ref="noticeDialogue" :item="one_time_notice"></noticeDialogue>
        <!-- NEW_DEV-1831 cyber end -->
      </div>
    </div>
    <v-overlay :value="loading">
      <v-progress-circular :size="80" :width="2" class="maincolor" indeterminate></v-progress-circular>
    </v-overlay>
  <GlobalFooter v-if="init.preview == 1 && init.menu_data" :menus="init.menu_data" />
  </v-content>
</template>

<script>
import Slick from "vue-slick";
import "../../../node_modules/slick-carousel/slick/slick.css";
import TopCoupon from "@/views/top/topCoupon.vue";
import TopPoint from "@/views/top/topPoint.vue";
import TopCStamp from "@/views/top/topCStamp.vue";
import TopBooking from "@/views/top/topBooking.vue";
import TopDigitalTicket from "@/views/top/topDigitalTicket.vue";
import TopNotification from "@/views/top/topNotification.vue";
import TopTalk from "@/views/top/topTalk.vue";
import TopMop from "@/views/top/topMop.vue";
import TopMopGindako from "@/views/top/topMopGindako.vue";
import TopShopping from "@/views/top/topShopping.vue";
import TopReserve from "@/views/top/topReserve.vue";
import TopDelivery from "@/views/top/topDelivery.vue";
import topCExternalLink from "@/views/top/topCExternalLink.vue";
import GlobalFooter from "@/components/global_footer.vue"
// NEW_DEV-1831 cyber start
import noticeDialogue from "@/components/notice_dialog.vue"
// NEW_DEV-1831 cyber end
export default {
  components: {
    Slick,
    TopCoupon,
    TopPoint,
    TopCStamp,
    TopBooking,
    TopDigitalTicket,
    TopNotification,
    TopTalk,
    TopMop,
    GlobalFooter,
    TopShopping,
    TopReserve,
    TopDelivery,
    topCExternalLink,
    // NEW_DEV-1831 cyber start
    TopMopGindako,
    noticeDialogue,
    // NEW_DEV-1831 cyber end
  },
  data() {
    return {
      init: [],
      slickOptions: {
        slidesToShow: 1,
        centerMode: true,
        centerPadding: "28px",
        arrows: false,
        variableWidth: true,
      },
      menu_list: null,
      coupon: null,
      stamp: null,
      digitalticket: null,
      digital_purchased_list: null,
      notification: null,
      talk: null,
      point: null,
      booking: null,
      menuloadflg: 0,
      badgeParams: {},
      // NEW_DEV-1831 cyber start
      one_time_notice: [],
      isStartUp: null,
      one_time_notice_list: [],
      // NEW_DEV-1831 cyber end
      loading: false,
    };
  },
  mounted() {    
    if(this.$route.query.preview) {  
      // リスナー追加
      document.addEventListener('keydown', this.onKeyDown);
      document.addEventListener('mousewheel', this.onMouseWheelFunc, { passive: false } );           

    }
  },
  beforeDestroy() {
    if(this.$route.query.preview) {
      // リスナー削除
      document.removeEventListener('keydown', this.onKeyDown);
      document.removeEventListener('mousewheel', this.onMouseWheelFunc);
    }
  },
  async created() {
    // viewport 拡大縮小をOFFにするmetaタグ追加
    var head = document.head;
    var metaVieportElement = document.createElement("meta");
    metaVieportElement.setAttribute("name","viewport"); 
    metaVieportElement.setAttribute("content","width=device-width,initial-scale=1.0,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no"); 
    head.appendChild(metaVieportElement); 

    //画面縦サイズを取得
    var wh = window.innerHeight
    if(wh > 590){
      const elem = document.getElementById('app');
      elem.classList.add('bh');
    }

    //createdで、localstrageから全ての保存情報を取得しinitに格納
    this.init = this.storageGet("*");

    /* axiosで画面表示時、トップメニューリスト情報取得API実行 */
    this.menu_list = await this.apiCall(
      "user/topmenu/2",
      {
        params: {
          sid: this.init.sid,
          service_cd: this.init.service_cd,
          device_uid: this.init.device_uid,
          device_id: this.init.device_id,
          os: this.init.os,
          key: this.init.key,
          preview: this.$route.query.preview, //isPreview Getパラメータがある場合は、APIにisPreviewを渡す
          // 20201105 外部リンク追加対応 cyber 董 start
          createFlag: this.$route.query.createFlag, //未保存が新規プレビューデータ表示・非表示フラグ
          // 20201105 外部リンク追加対応 cyber 董 end
          //NEW_DEV-2220 cyber start
          'regist_layout_flg': this.getUrlGetParam('registLayoutFlg')
          //NEW_DEV-2220 cyber end
        }
      },
      "get"
    );

    if (!this.menu_list) return false;
    // NEW_DEV-1831 cyber start
    window.getIsStartUp = this.getIsStartUp;
    let params = {
        '_vue_param': true,
        'top_display': true,
    };
    // NEW_DEV-2220 cyber start
    if(this.$route.query.preview != 1){
        alert(JSON.stringify(params));
    }
    // NEW_DEV-2220 cyber end
    this.one_time_notice_list = this.menu_list.one_time_notice_list;
    // NEW_DEV-1831 cyber end

    var api_url,
      api_res,
      save_name = null; // 事前に各APIを叩く為の、データの格納先を用意

    for (var i = 0; i < this.menu_list.menus.length; i++) {
      var api_req = {
        params: {
          sid: this.init.sid,
          service_cd: this.init.service_cd,
          device_uid: this.init.device_uid,
          device_id: this.init.device_id,
          os: this.init.os,
          key: this.init.key,
          preview: this.$route.query.preview, //preview Getパラメータがある場合は、APIにisPreviewを渡す
          // 20201105 外部リンク追加対応 cyber 董 start
          createFlag: this.$route.query.createFlag, //未保存が新規プレビューデータ表示・非表示フラグ
          // 20201105 外部リンク追加対応 cyber 董 end
        }
      };
      // トップメニューリスト情報取得API（B,C)の結果に応じて、ループ処理で順番にAPIを叩く。
      //console.log(this.menu_list.menus[i].feature_id);
      switch (this.menu_list.menus[i].feature_id) {
        case "coupon":
          Object.assign(api_req.params, { shop_id: null, page: 1 });
          api_url = "/user/coupons";
          save_name = "coupon";
          break;
        case "stamp":
          Object.assign(api_req.params, { shop_id: null, page: 1, limit: 1 });
          api_url = "/stamp/top-list";
          save_name = "stamp";
          break;
        case "digital_ticket":
          Object.assign(api_req.params, {
            shop_id: this.init.sid,
            is_bought: 0,
            page: 1
          });
          api_url = "/digitalticket/list";
          save_name = "digitalticket";
          break;
        // 購入済みタブ側の情報は、購入済みタブが押された時に取得するよう、そちらに移す(API処理分散したい方針だったはず)
        case "notification":
          Object.assign(api_req.params, { shop_id: null, page: 1 });
          api_url = "/user/notifications";
          save_name = "notification";
          break;
        case "talk":
          //20210122 NEW_DEV-743 cyber start
          Object.assign(api_req.params, { shop_id: this.init.sid, page: 1, device_uid: this.init.device_uid, isTop:2 });
          //20210122 NEW_DEV-743 cyber end
          api_url = "/talk/timeline";
          save_name = "talk";
          break;
        case "point":
          api_url = "/point";
          save_name = "point";
          break;
        case "booking":
          Object.assign(api_req.params, { page: 1, limit: 1 });
          api_url = "/user/booking";
          save_name = "booking";
          break;
        default:
          continue;
      }
      //console.log(this[save_name]);
      api_res = await this.apiCall(api_url, api_req);
      if (!api_res) continue; // resが返らない時のエラーは共通エラー処理でやるので、処理中断だけで良い。
      this.$set(this, save_name, api_res);
    }
    this.menuloadflg = 1
  },
  methods: {
    fetchData(){ //init apiが読み込まれた場合initに値を入れる
        this.init = this.storageGet('*')

        //バッジ数をネイティブに送る
        this.badgeParams['_vue_param'] = true;
        this.badgeParams['menu_data'] = this.init.menu_data;
        this.badgeParams['total_unread_count'] = this.init.total_unread_count;
        //console.log(this.badgeParams)
        this.nativePost(this.badgeParams);
    },
    async NextRouting(
      destination,
      feature_id,
      screen_id,
      transition_type,
      top_type,
      cassette_id,
      transition_info,
      page_title,
    ) {
      try {
        // プレビューの場合は通常遷移させる
        if (this.$route.query.preview) {
          return window.location.href = destination + '?sid=' + this.init.sid + '&preview=1';
        }
        // 多重処理防止
        if (this.loading) return
        this.loading = true
        
        //タップAPI
        var tap_req = {
          sid: this.init.sid,
          service_cd: this.init.service_cd,
          device_uid: this.init.device_uid,
          device_id: this.init.device_id,
          os: this.init.os,
          key: this.init.key,
          top_type: top_type,
          cassette_id: cassette_id,
          transition_type: transition_type,
          transition_info: transition_info
        };
        var tap_res = await this.apiCall("/user/tap", tap_req, "post");
        if (!tap_res) { return false; }

        //ルーティングAPI
        var tonative_req = {
          destination: destination,
          feature_id: feature_id,
          screen_id: screen_id,
          transition_type: transition_type,
          page_title: page_title,
        };
        var business_service_req = {params: {
            'sid': this.storageGet('sid')
          }}
        var business_service_res = await this.apiCall('/business-service/get-info', business_service_req)
        if (!business_service_res.data) return false;
        if (destination.indexOf('mop') != -1) {          
          const moplink = "https://" + process.env.VUE_APP_HOST_NAME + "/mop/shop-list?sid="+this.init.sid+"&os="+this.init.os+"&device_id="+this.init.device_id+"&key="+this.init.key+"&registration_id="+this.init.registration_id+"&app_version="+this.init.app_version+"&feature_id=1&device_uid="+this.init.device_uid+"&business_code="+business_service_res.data.business_code;
          location.replace(moplink);
          return;
        }

        if (!this.screenTransition(tonative_req)) {
          // 遷移失敗・遷移情報が変な時もエラー表示があった方が良い？
          this.callDialog(
            "遷移エラー",
            "遷移情報が不正です。再度アクセスして下さい。",
            2
          );
        }
      } catch (e) {
        this.callDialog(
          "通信エラー",
          "ネットワークの状態が不安定です。再度お試しください",
          3
        );
      } finally {
        // 正常, 異常に関わらず処理完了時はスピナー解除
        this.loading = false
      }
    },
    toMOP(){
      var destination = 'https://' + process.env.VUE_APP_HOST_NAME + "/sp/mop"
      var feature_id = 1
      var screen_id = "top"
      var transition_type = 2
      var top_type = 1
      var cassette_id = 1
      var transition_info = "mop"
      var page_title = "モバイルオーダー"

      this.NextRouting(
        destination,
        feature_id,
        screen_id,
        transition_type,
        top_type,
        cassette_id,
        transition_info,
        page_title,
      )
    },
    toShopping(){
      var destination = 'https://www.sakanaya-kadohachi.com/online-shop'
      var feature_id = 1
      var screen_id = "top"
      var transition_type = 4
      var top_type = 1
      var cassette_id = 1
      var transition_info = "shopping"
      var page_title = "SHOPPING"

      this.NextRouting(
        destination,
        feature_id,
        screen_id,
        transition_type,
        top_type,
        cassette_id,
        transition_info,
        page_title,
      )
    },
    toReserve(){
      var destination = 'https://www.sakanaya-kadohachi.com/%E4%BA%8B%E5%89%8D%E3%82%AA%E3%83%BC%E3%83%80%E3%83%BC'
      var feature_id = 1
      var screen_id = "top"
      var transition_type = 4
      var top_type = 1
      var cassette_id = 1
      var transition_info = "reserve"
      var page_title = "商品注文予約"

      this.NextRouting(
        destination,
        feature_id,
        screen_id,
        transition_type,
        top_type,
        cassette_id,
        transition_info,
        page_title,
      )
    },
    toDelivery(){
      var destination = 'https://www.ubereats.com/tokyo/food-delivery/%E9%AD%9A%E5%B1%8B-%E3%81%8B%E3%81%A8%E3%81%AF%E3%81%A1-%E4%BB%A3%E5%AE%98%E5%B1%B1%E5%BA%97-sakanaya-kadohachi/Nze9FosuTDKR7atN6xg_Gg'
      var feature_id = 1
      var screen_id = "top"
      var transition_type = 4
      var top_type = 1
      var cassette_id = 1
      var transition_info = "delivery"
      var page_title = "デリバリー"

      this.NextRouting(
        destination,
        feature_id,
        screen_id,
        transition_type,
        top_type,
        cassette_id,
        transition_info,
        page_title,
      )
    },
    // NEW_DEV-1831 cyber start
    inArray(search,array){
        for(var i in array){
            if(array[i]==search){
                return true;
            }
        }
        return false;
    },
    async getIsStartUp(isStartUp){
      this.isStartUp = isStartUp
    },
    // NEW_DEV-1831 cyber end
    
    onKeyDown(event) {
      // Windows.Ctrlキー,または, Mac.commandキー 押下時
      // 拡大縮小キー（日本語配列「-」,「;」, 英字配列「-」,「=」) でコマンド無効化*/
      if (event.ctrlKey || event.metaKey) {
          if(event.code == 'Minus' || event.code == 'Equal' || event.code == 'Semicolon') {
              if (event.preventDefault()){
                  event.preventDefault();
              } else {
                  return false;
              }
          }
      }   
    },
    onMouseWheelFunc(event) {
      // Windows.Ctrlキー,または, Mac.commandキー 押下時
      // マウスホイールによる拡大縮小無効化
      if (((event.ctrlKey || event.metaKey))) {
          if (event.preventDefault()){
              event.preventDefault();
          } else {
              return false;
          }
      }
    },
  },
  watch: {
    '$root.init_flg': 'fetchData',
    // NEW_DEV-1831 cyber start
    isStartUp: function() {
      let userId = 'userId' + this.init.user_id;
      let objtoken = null;
      if(this.one_time_notice_list != null && this.isStartUp == 1){
        let top_one_time_notice_ids = this.storageGet('top_one_time_notice_ids');
        if(top_one_time_notice_ids && top_one_time_notice_ids.length != 0){
          let ids = top_one_time_notice_ids[userId];
          for (const elem of this.one_time_notice_list) {
            if (!this.inArray(elem.id, ids)) {
              this.$set(this, 'one_time_notice', elem);
              ids.push(elem.id);
              top_one_time_notice_ids[userId] = ids;
              objtoken = (JSON.stringify({
                            'top_one_time_notice_ids': top_one_time_notice_ids
                          }))
              this.storageSave(objtoken)
              this.$refs.noticeDialogue.open();
              break;
            }
          }
        }else{
          let res = this.one_time_notice_list[0];
          this.$set(this, 'one_time_notice', res);
          let ids = new Array();
          ids.push(res.id);
          let new_top_one_time_notice_ids = {};
          new_top_one_time_notice_ids[userId] = ids;
          objtoken = (JSON.stringify({
                        'top_one_time_notice_ids': new_top_one_time_notice_ids
                      }))
          this.storageSave(objtoken)
          this.$refs.noticeDialogue.open();
        }
      }
    },
    // NEW_DEV-1831 cyber end
    menuloadflg: function() {
      this.$refs.slick.destroy();
      this.$nextTick(() => {
        this.$refs.slick.create();
      });
    }
  }
};
</script>

<style scoped>
/* ページレイアウト */
.wrap {
  background-attachment: fixed !important;
  background-size: cover !important;
  background-position: center !important;
  background: -moz-linear-gradient(-58deg, #cee6ff, #f8cff5);
  background: -webkit-linear-gradient(-58deg, #cee6ff, #f8cff5);
  background: linear-gradient(148deg, #cee6ff, #f8cff5);
}

.body {
  overflow-y: auto;
  -ms-overflow-style: none !important;
  scrollbar-width: none !important;
}
.body::-webkit-scrollbar {
  /* Chrome, Safari 対応 */
  display: none;
}
.logo {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 3;
    width: 100%;
}
.slider {
  margin-top: 70px;
}
.v-application .slider {
  margin-bottom: 60px;
}
.v-application.bh .slider {
  margin-bottom: 0px;
}

</style>
<style>
  .v-application.bh {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
  }

</style>
